var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eewc-loading-spinner',{attrs:{"is-loading":_vm.loading && !_vm.preventLoading}}),_c('canvas',{ref:"previewImage",staticClass:"preview-canvas",attrs:{"id":`preview-image-${_vm.cameraId}`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }